

export default function ControloEQualidade() {


    return(<>Controlo e Qualidade Form</>)

}